import React, { Component } from "react"
import intl from "react-intl-universal"
import { Pagination, Select, Table, Space, Button } from "antd"
import { getOrderList } from "../../../api/console/order/Order"
import { Link, Outlet } from 'react-router-dom'

const { Option } = Select

// 1、待付款;2、待确认;4、生效中;5、已失效;
const ORDER_STATUS_WAIT_PAY = 1
const ORDER_STATUS_ALREADY_PAY = 2
const ORDER_STATUS_SERVING = 4
const ORDER_STATUS_SERVICE_EXPIRED = 5

class List extends Component {

    constructor(props) {
        super(props)
        this.state = {
            orderList: [],
            initDone: false,
            totalSize: 0,
            currentPage: 1,
            pageSize: 15,
            status: '',
        }
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.changePage = this.changePage.bind(this)

    }


    componentWillMount () {
        this.getOrderList()
    }


    getOrderList () {
        let that = this
        let { currentPage, pageSize, status } = that.state
        getOrderList(currentPage, pageSize, status).then((res) => {
            if (res.code === 0) {
                this.setState({
                    orderList: res.data.list,
                    initDone: true,
                    totalSize: res.data.total,
                })
            }
        }, (error) => {
            console.log("get response failed!")
        }
        )
    }

    changePage (page, pageSize) {
        this.setState({
            currentPage: page,
            pageSize: pageSize,
            loading: true,
        }, this.getOrderList)
    }

    onChangeStatus (value) {
        console.log(`selected ${value}`)
        this.setState({
            currentPage: 1,
            loading: true,
            status: value
        }, this.getOrderList)
    }

    render () {
        const { orderList, initDone, currentPage, pageSize, totalSize } = this.state

        const columns = [
            {
                title: intl.get('order.list_col1'),
                dataIndex: 'orderNumber',
                key: 'orderNumber',
                // render: text => <a>{text}</a>,
            },
            {
                title: intl.get('order.list_col2'),
                dataIndex: 'comboName',
                key: 'comboName',
            },
            {
                title: intl.get('order.list_col3'),
                dataIndex: 'corpName',
                key: 'corpName',
            },
            {
                title: intl.get('order.list_col4'),
                dataIndex: 'createdAt',
                key: 'createdAt',
            },
            {
                title: intl.get('order.list_col5'),
                dataIndex: 'amount',
                key: 'amount',
            },
            {
                title: intl.get('order.list_col6'),
                dataIndex: 'statusCw',
                key: 'statusCw',
            },
            {
                title: intl.get('order.list_col7'),
                dataIndex: 'payType',
                key: 'payType',
            },
            {
                title: intl.get('order.list_col8'),
                key: 'action',
                render: (_, record) => (
                    <Space size="middle">
                        {
                            record.status < 2
                                ? (<Link to={"/order/pay?orderId=" + record.id}>{intl.get('order.list_do1')}</Link>)
                                : (<Link to={"/order/detail?orderId=" + record.id}>{intl.get('order.list_do2')}</Link>)
                        }
                        <Outlet />
                    </Space>
                ),
            },
        ]

        return (
            initDone &&
            <div>
                <div className="welcome">
                    <div className="align-items-center" style={{ width: '100%', display: 'flex', justifyContent: "space-between", padding: '0 20px' }}>
                        <div className="font-20-l28">
                            {intl.get('order.list_title1')}
                        </div>
                        <div></div>
                    </div>
                </div>
                <div className="content">
                    <div style={{ padding: '16px 12px 70px 12px' }}>

                        <div className="row pb-3" style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <div className="col-12" style={{ padding: '0 8px' }}>
                                <div className="bg-white mb-3">
                                    <div className="a-card-header">
                                        <div className="mx-2 d-flex justify-content-between align-items-center">
                                            <div className="font-16-l24">{intl.get('order.list_title2')}</div>
                                        </div>
                                    </div>

                                    <div className="px-4 p-3">
                                        <div className="align-items-center justify-content-between" style={{ width: '100%', display: 'flex', padding: '0 0 20px 0' }}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div style={{ marginRight: '10px' }}>{intl.get('order.list_col6')}</div>
                                                <Select
                                                    style={{ width: 160 }}
                                                    placeholder={intl.get('order.option_all')}
                                                    onChange={this.onChangeStatus}
                                                >
                                                    <Option value="">{intl.get('order.option_all')}</Option>
                                                    <Option value={ORDER_STATUS_WAIT_PAY}>{intl.get('order.option_wait')}</Option>
                                                    <Option value={ORDER_STATUS_ALREADY_PAY}>{intl.get('order.option_already')}</Option>
                                                    <Option value={ORDER_STATUS_SERVING}>{intl.get('order.option_serving')}</Option>
                                                    <Option value={ORDER_STATUS_SERVICE_EXPIRED}>{intl.get('order.option_expired')}</Option>
                                                </Select>
                                            </div>
                                            <div>
                                                <Link to="/order/create?combo=1"><Button type="primary">{intl.get('order.buy_combo')}</Button></Link>

                                            </div>
                                        </div>

                                        <Table columns={columns} dataSource={orderList} pagination={false} />
                                        <div className="mt-3 text-right">
                                            <Pagination current={currentPage} pageSize={pageSize}
                                                total={totalSize} showTotal={(total) => `Total ${Math.ceil(totalSize / pageSize)} pages`}
                                                onChange={this.changePage} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default List
